import React, { useState } from 'react';
import { FiInbox, FiMail, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import MessageDetailPanel from './MessageDetailPanel';
import { useMessages } from '../hooks/useMessages';
import { useEmail } from '../hooks/useEmail';
import { formatDate } from '../utils/dateUtils';

const InboxSection = () => {
    const [selectedMessage, setSelectedMessage] = useState(null);
    const { tempEmail } = useEmail();
    const { messages, currentPage, totalPages, handlePageChange } = useMessages(tempEmail);

    return (
        <div className="inbox-section">
            <div className="inbox-header">
                <h2><FiInbox /> Inbox</h2>
            </div>
            <div className="messages-container">
                {messages.length === 0 ? (
                    <div className="empty-state">
                        <FiMail />
                        <p>No messages yet. They will appear here automatically.</p>
                    </div>
                ) : (
                    <>
                        <div className="messages-list">
                            {messages.map(message => (
                                <div 
                                    key={message.id} 
                                    className={`message-row ${!message.read ? 'unread' : ''}`}
                                    onClick={() => setSelectedMessage(message)}
                                >
                                    <div className="message-preview">
                                        <div className="message-preview-header">
                                            <h3>{message.subject || 'No Subject'}</h3>
                                            <span className="message-time">
                                                {formatDate(message.receivedAt)}
                                            </span>
                                        </div>
                                        <div className="message-preview-content">
                                            <span className="sender">{message.sender}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="pagination">
                            <button 
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                <FiChevronLeft />
                            </button>
                            <span>Page {currentPage} of {totalPages}</span>
                            <button 
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                <FiChevronRight />
                            </button>
                        </div>
                    </>
                )}
            </div>

            <MessageDetailPanel 
                selectedMessage={selectedMessage}
                setSelectedMessage={setSelectedMessage}
            />
        </div>
    );
};

export default InboxSection; 